'use client';

import { Grid, GridItem, Box } from '@chakra-ui/react';
import BlogPostCard from './BlogPostCard';
import { useBlogService } from '@/hooks/blog/useBlogPosts';

const BlogList = () => {
  const { useGetBlogPostsSummary } = useBlogService();
  const { data: blogPosts } = useGetBlogPostsSummary({ limit: 6 });

  return (
    <Box width="100%" display={{ base: 'block', tablet: 'none', desktop: 'none' }}>
      <Grid alignItems="center" gap={4} templateColumns="repeat(2, 1fr)" width="100%">
        {blogPosts.slice(0, 4).map((post) => (
          <GridItem key={post.id}>
            <BlogPostCard
              title={post.title}
              image={post.thumbnailUrl1024x512}
              date={post.publishedAt}
              readTime={`${post.readingTimeMinutes} min read`}
              link={post.url}
            />
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};

export default BlogList;
